var Backbone = require('backbone');
var _ = require('lodash');
var $ = require('jquery');
var cookie = require('./../util/cookie');
var PubSub = require('tscom-pubsub');
var AUTH_CONST = require('./../constants').facebook;

module.exports = Backbone.Model.extend({
    scriptLoaded: false,

    defaults: {
        appId: null,
        authResponse: null,
        status: null,
        scope: 'email',
        namespace: null,
        insideMobileApp: null,
        reauthEnabled: false,
        user: null,

        share: {
            method: 'share',
            caption: ''
        },
        shareResponse: null,
        timelineSharing: 0,
        publishActionPermRequested: 0,
        VoteArtistShareID: null,
        VoteArtistShared: 0,
        voteRemoved: null,
        VoteArtistMessageAdded: null,

        scriptLoaded: false,

        postToTimeline: true,
        showEpisode: null,
        envCon: null,

        publishImplicitWatchActionID: null,
        publishExplicitWatchActionID: null,
        publishExplicitWatchActionRemoved: null
    },
    /**
     * [ initialize ]
     */
    initialize: function() {
        _.bindAll(this, 'getLoginStatus', 'loginResponse');
        this.checkScript();
    },
    /**
     * [ checkScript ]
     */
    checkScript: function() {
        if (_.isUndefined(window.fbAsyncInit)) {
            this.initScript();
        } else {
            this.getLoginStatus();
            this.set('scriptLoaded', true);
        }
    },
    /**
     * [ initScript ]
     */
    initScript: function() {
        var e = document.createElement('script');
        e.async = true;
        e.src = 'https://connect.facebook.net/en_US/sdk.js';
        document.getElementById('fb-root').appendChild(e);

        window.fbAsyncInit = this.loadScript.bind(this);
    },
    /**
     * [ loadScript ]
     */
    loadScript: function() {

        this.set('scriptLoaded', true);

        FB.init({
            appId: this.get('appId'),
            status: true,
            version: 'v3.2'
        });

        this.getLoginStatus();
    },
    /**
     * [ clearUser ]
     */
    clearUser: function() {
        this.set({ user: null });
    },
    /**
     * [ getLoginStatus ]
     */
    getLoginStatus: function() {
        console.log('run getLoginStatus');
        FB.getLoginStatus(this.loginResponse.bind(this), true);
    },
    /**
     * [ loginResponse ]
     */
    loginResponse: function(response) {
        console.log('fb login response', response);

        this.set({
            authResponse: response.authResponse,
            status: response.status
        });

        this.getUserData();
    },
    /**
     * [ manualLoginResponse ]
     */
    manualLoginResponse: function(deferred, response) {
        console.log('manualLoginResponse', response);

        var identifier = response.id;
        delete response.id;

        var user = _.extend({}, response, {
            identifier: identifier
        });

        this.set('user', user);

        deferred.resolve(user);
    },
    /**
     * [ getUserData ]
     */
    getUserData: function() {
        if (this.get('status') === AUTH_CONST.LOGIN_STATUS.CONNECTED) {
            if (
                !this.get('user') &&
                this.get('authResponse') &&
                this.get('authResponse').userID
            ) {
                FB.api(
                    '/' +
                        this.get('authResponse').userID +
                        '?fields=id,first_name,last_name,email,name,permissions',
                    this.handleFbUserData.bind(this),
                    true
                );
            }
        } else {
            // do something else
            // FB.login(_.bind(this.loginResponse, this), {scope: this.get('scope'), auth_type: 'rerequest'});
            //this.getUserData();
        }
    },
    /**
     * Check user permissions if email is granted, then set the user data
     */
    handleFbUserData: function(response) {
        console.log('FB Response User Data with Permissions',response);
        if(!this.get('reauthEnabled') || (response.permissions && !response.permissions.data.length)) return this.setUser(response);

        // Use Array.filter instead of Array.find to support previous IE versions
        var emailPermission = response.permissions.data.filter(function(obj) {
            return obj.permission === 'email';
        })[0];

        if(emailPermission.status === AUTH_CONST.PERMISSION_STATUS.DECLINED) {
            PubSub.trigger('facebook:rerequest');
            return;
        }

        this.setUser(response);
    },
    /**
     * Prompt the user to grant permissions
     */
    requestPermissions: function() {
        FB.login(this.loginResponse.bind(this), {
            auth_type: AUTH_CONST.AUTH_TYPE.REAUTH,
            scope: this.get('scope')
        });
    },
    /**
     * [ setUser ]
     */
    setUser: function(response) {
        console.log('setUser response:\t', response);

        var user = {
            identifier: response.id,
            first_name: response.first_name,
            last_name: response.last_name,
            name: response.name,
            email: response.email,
            permissions: !_.isObject(response.permissions.data[0]) ? {} : response.permissions.data[0]
        };

        console.log('formatted user ->\t', user);
        this.set({ user: user });
    },
    /**
     * [ setUserDataWithToken ]
     */
    setUserDataWithToken: function(deferred) {
        if (this.get('scriptLoaded') === false) {
            // once we know the SDK has loaded we can init the Router
            this.once(
                'change:scriptLoaded',
                function() {
                    this.setUserDataWithToken(deferred);
                }.bind(this)
            );
            return false;
        }

        console.log('setUserDataWithToken');

        FB.api(
            '/me',
            {
                fields: 'id,first_name,last_name,email,name,permissions',
                access_token: this.get('accessToken')
            },
            this.manualLoginResponse.bind(this, deferred)
        );
    },
    /**
     * [ manualRedirectURI ]
     */
    manualRedirectURI: function() {
        var redirectURI = (top !== self
            ? document.referrer
            : window.location.href
        )
            .split('#')[0]
            .replace(/(.*\?).*/g, '$1');
        var qspWhitelist = {
            app: _.contains(['native'], _.getQueryParamByName('app'))
                ? _.getQueryParamByName('app')
                : ''
        };

        _.each(qspWhitelist, function(value, key) {
            qspWhitelist =
                value.length === 0 ? _.omit(qspWhitelist, key) : qspWhitelist;
        });

        return (
            redirectURI +
            (redirectURI.charAt(redirectURI.length - 1) === '?' ? '' : '?') +
            $.param(qspWhitelist) +
            '#auth'
        );
    },
    /**
     * [ manualLogin ]
     */
    manualLogin: function() {
        var params = $.param({
            client_id: this.get('appId'),
            response_type: 'token',
            scope: { scope: 'email' },
            redirect_uri: this.manualRedirectURI() //'http://local.smpd.votenow.tv/#auth?app=native'
        });

        console.info(
            'manual login',
            encodeURI('https://www.facebook.com/v2.2/dialog/oauth?') + params
        );
        window.top.location =
            encodeURI('https://www.facebook.com/v2.2/dialog/oauth?') + params;
    },
    /**
     * [ login ]
     */
    login: function() {
        console.log('scope: ', this.get('scope'));
        FB.login(this.loginResponse.bind(this), {
            scope: this.get('scope')
        });
    },
    /**
     * [ logout ]
     */
    logout: function(callback) {
        if (typeof callback != 'function') callback = null;

        FB.getLoginStatus(
            function(response) {
                // Make sure user is logged in before trying to logout, otherwise there is an error
                if (response.status === AUTH_CONST.LOGIN_STATUS.CONNECTED) {
                    FB.logout(this.logoutResponse.bind(this, callback));
                } else {
                    this.logoutResponse(response, callback);
                }
            }.bind(this),
            true
        );

        if (this.get('insideMobileApp')) {
            cookie.eraseCookie('manualLogin');
        }
    },
    /**
     * [ logoutResponse ]
     */
    logoutResponse: function(response, callback) {
        console.log('response', response, 'callback', callback);
        // Flip the params and retry
        if (_.isFunction(response)) {
            console.log('response is a function');
            this.logoutResponse(callback, response);
            return;
        }

        console.log('logoutResponse', callback, response);
        this.set({ authResponse: null, status: null });
        this.clearUser();
        if (typeof callback == 'function') callback();
    },
    /**
     * [ isConnected ]
     */
    isConnected: function(callback) {
        console.log('isConnected',callback);

        if (typeof callback != 'function') return;

        if (this.get('status') === AUTH_CONST.LOGIN_STATUS.CONNECTED && this.get('user')) {
            console.log('status user');
            callback(true);
        } else {
            this.set({ status: null }, { silent: true });
            this.once(
                'change:status',
                function(model, value) {
                    console.log('isConnected listener value',value,'status:',this.get('status'),'authresponse:',this.get('authResponse'));
                    if (this.get('status') === AUTH_CONST.LOGIN_STATUS.CONNECTED) {
                        // get user data before sending back true
                        this.once('change:user',function() {
                            callback(true);
                        });

                        this.getUserData();
                    } else {
                        callback(false);
                    }
                }.bind(this)
            );
            // make sure the SDK has loaded and the FB object is defined
            if (this.get('scriptLoaded') === true) {
                console.log('script loaded');
                this.get('insideMobileApp') ? this.manualLogin() : this.login();
            } else {
                console.log('wait for script');
                // once we know the SDK has loaded we can init the Router
                this.once(
                    'change:scriptLoaded',
                    function() {
                        this.get('insideMobileApp') ? this.manualLogin() : this.login();
                    }.bind(this)
                );
            }
        }
    },
    /**
     * [ share ]
     */
    share: function(shareURL) {
        var shareDefaults = this.get('share');
        shareDefaults.href = shareURL;
        FB.ui(shareDefaults, this.shareResponse.bind(this));
    },
    /**
     * [ shareResponse ]
     */
    shareResponse: function(response) {
        console.log('shareResponse', response, $.type(response));

        if ($.type(response) === 'object' && _.has(response, 'post_id')) {
            this.set({ VoteArtistShared: 1 });
        }

        this.set({ shareResponse: response });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/models/facebook.js
// module id = 199
// module chunks = 0